<template>
  <div class="home">
    <transition name="fade">
      <LoadingLayer v-if="progress < 100" :progress="progress" />
    </transition>
    <div class="top">
      <div class="icon"></div>
      <div @click="toCreater" class="btn"></div>
      <div class="text-top"></div>
      <div class="text-box">
        <div class="text-1">“爱上上虞的100个理由”短视频征集大赛正式开启</div>
        <div @click="toIntro" class="blue-text">活动简介 ></div>
      </div>
      <div class="outer-title"></div>
    </div>
    <div class="outer-box">
      <div v-if="false" class="search-box">
        <input
          placeholder="请输入搜索关键字"
          v-model="searchword"
          type="text"
        />
        <div class="search-btn" @click="toSearch">立即搜索</div>
      </div>
      <div class="content-box">
        <div class="list-common rank-list">
          <div
            class="item"
            @click="toDetail(item.id)"
            v-for="(item, index) in listRank"
            :key="index"
          >
            <div v-if="item.id" :class="item.rank"></div>
            <img v-if="item.id" :src="item.picture" alt="" />
            <div v-if="item.id" class="bottom-box">
              <div class="name">@{{ item.extra.auther }}</div>
              <div class="title">{{ item.extra.name }}</div>
            </div>
          </div>
        </div>
        <div class="nice-title"></div>
        <div class="list-common">
          <waterfall
            :col="3"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
            :data="listNice"
            :loadDistance="100"
            @loadmore="loadmore"
            @finish="hideLoading"
          >
            <template>
              <div
                class="real-list"
                @click="toDetail(item.id)"
                v-for="(item, index) in listNice"
                :key="index"
              >
                <div :class="item.rank"></div>
                <img :src="item.picture" alt="" />
                <div class="bottom-box">
                  <div class="name">@{{ item.extra.auther }}</div>
                  <div class="title">{{ item.extra.name }}</div>
                </div>
              </div>
            </template>
          </waterfall>
        </div>
        <div class="tran-title"></div>
        <div class="list-common">
          <waterfall
            :col="3"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
            :data="listTran"
            :loadDistance="100"
            @loadmore="loadmore"
            @finish="hideLoading"
          >
            <template>
              <div
                class="real-list"
                @click="toDetail(item.id)"
                v-for="(item, index) in listTran"
                :key="index"
              >
                <div :class="item.rank"></div>
                <img :src="item.picture" alt="" />
                <div class="bottom-box">
                  <div class="name">@{{ item.extra.auther }}</div>
                  <div class="title">{{ item.extra.name }}</div>
                </div>
              </div>
            </template>
          </waterfall>
        </div>
      </div>
    </div>
    <div class="other-title"></div>
    <div class="outer-box">
      <div class="content">
        <waterfall
          :col="3"
          :width="itemWidth"
          :gutterWidth="gutterWidth"
          :data="listOther"
          :loadDistance="100"
          @loadmore="loadmore"
          @finish="hideLoading"
        >
          <template>
            <div
              class="real-list"
              @click="toDetail(item.id)"
              v-for="(item, index) in listOther"
              :key="index"
            >
              <img :src="item.picture" alt="" />
              <div class="bottom-box">
                <div class="name">@{{ item.extra.auther }}</div>
                <div class="title">{{ item.extra.name }}</div>
              </div>
            </div>
          </template>
        </waterfall>
        <!-- <div v-if="isLastPage" class="is-last">
          没有更多了
        </div> -->
        <!-- <div v-else-if="loading" class="is-last">加载中···</div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoadingLayer from "../components/LoadingLayer.vue";
import { wxShare } from "../utils/wxUtils.js";
import { getInfo, getVoteList, getAlbumList } from "../service/index.js";
export default {
  name: "Home",
  data() {
    return {
      // actId: 81,
      actId: 40,
      list: [],
      progress: 0,
      shareApp: null,
      searchword: "",
      hudong_activity_id: 0,
      type: "",
      refreshing: false,
      loading: true,
      isLastPage: false, // 最后一页，不再触发触底事件
      isEmpty: 0, // 0 加载中  1 加载成功  2 加载失败
      pageNum: 1, // 列表页码
      pageSize: 10, // 一页数据大小
      listRank: [],
      listNice: [],
      listTran: [],
      listOther: []
    };
  },
  components: {
    LoadingLayer
  },
  created() {
    // 静态资源加载
    const images = [require("../assets/img/icon_music.png")];
    let l = images.length;
    let loadedNum = 0;
    for (let i = 0; i < l; i++) {
      let image = new Image();
      image.onload = () => {
        loadedNum++;
        this.progress = (loadedNum / l) * 100;
        if (loadedNum === l) {
          console.log("资源加载完成！");
        }
      };
      image.src = images[i];
    }
    let ua_str = window.navigator.userAgent.toLowerCase();
    if (/chinabluetv/.test(ua_str)) {
      // 蓝tv app SDK 初始化
      const shareData = {
        showShareBtn: true,
        url: "", //分享的网址链接
        title: "", //分享的标题
        content: "", // 分享的文字
        img: "" // 分享的图片Url
      };
      // eslint-disable-next-line
      this.shareApp = new ShareApp("true", shareData);
      // 设置分享
      this.shareApp.changeShareInfo(shareData);
      // 获取用户信息
      this.shareApp.getUserInfo(res => {
        if (res) {
          var parse = JSON.parse(res);
          window.mToken = parse.access_token;
          console.log("mToken:" + window.mToken);
        } else {
          console.log("未登录");
          window.location.reload();
        }
      });
    } else {
      // 设置微信分享
      wxShare(
        true,
        "分享标题",
        "分享描述",
        "朋友圈分享标题",
        "分享地址",
        "分享图"
      );
    }
  },
  computed: {
    itemWidth() {
      // rem布局 计算列宽度
      // 可以根据自己的rem设置修改这里的 334 值
      return 368;
      // return 380 * (document.documentElement.clientWidth / 1920);
    },
    gutterWidth() {
      // rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)
      // 可以根据自己的rem设置修改这里的 36 值
      return 13 * (document.documentElement.clientWidth / 1920);
    }
  },
  mounted() {
    this.getActivityInfo();
    const ua = window.navigator.userAgent.toLowerCase();
    if (/micromessenger/.test(ua)) {
      wxShare(
        true,
        "爱上上虞的100个理由短视频征集大赛",
        "你为什么会爱上上虞，我们期待你的答案",
        "爱上上虞的100个理由短视频征集大赛",
        "https://mhudong.cztv.com/265381#/",
        "https://ohudong.cztv.com/hudong/admin/2022/10/24/0b1be65a01286d6ad81d3c3c0abe4f59.jpg"
      );
    }
  },
  methods: {
    toCreater() {
      if (this._isMobile()) {
        this.$toast("请在电脑端报名哦~");
      } else {
        window.location.href = "https://mp.cztv.com/#/publish?actId=40";
      }
    },
    toIntro() {
      this.$router.push("/intro");
    },
    toDetail(id) {
      if (id) {
        this.$router.push({ name: "detail", query: { id: id } });
      }
    },
    toSearch() {
      this.list = [];
      this.$nextTick(() => {
        this.$waterfall.forceUpdate();
      });
      this.getList();
    },
    async getAlbumList() {
      const res = await getAlbumList(this.actId);
      const data = res.data.list;
      // console.log(data);
      let rank1 = data[0].list.map(item => {
        let obj = item;
        obj.rank = "rank1";
        return obj;
      });
      let rank2 = data[1].list.map(item => {
        let obj = item;
        obj.rank = "rank2";
        return obj;
      });
      let rank3 = data[2].list.map(item => {
        let obj = item;
        obj.rank = "rank3";
        return obj;
      });

      this.listRank = this.listRank
        .concat(rank1)
        .concat(rank2)
        .concat(rank3);
      if (this.listRank.length % 3 == 2) {
        this.listRank.push({});
      }
      this.listNice = data[3].list;
      this.listTran = data[4].list;
      this.listOther = this.getOther(
        this.list,
        []
          .concat(this.listRank)
          .concat(this.listNice)
          .concat(this.listTran)
      );
      // console.log(this.listOther);
    },
    async getActivityInfo() {
      const res = await getInfo(this.actId);
      // console.log(res);
      this.hudong_activity_id = res.data.hudong_activity_id;
      this.getList();
    },
    getOther(arr1, arr2) {
      return arr1.filter(v => arr2.every(val => val.id != v.id));
    },
    hideLoading() {
      this.refreshing = false;
      this.loading = false;
    },
    async getList() {
      const res = await getVoteList(
        this.hudong_activity_id,
        1,
        this.searchword
      );
      const list = res?.data?.list;
      if (list && list.length > 0) {
        const newList = list.map(item => {
          return {
            ...item
          };
        });
        this.list = this.list.concat(newList);
        this.isLastPage = true;
      }
      this.getAlbumList();
    },
    loadmore(index) {
      return;
      console.log("loadmore");
      if (this.isLastPage) return;

      if (this.loading) return;
      this.loading = true;
      if (this.refreshing) {
        this.refreshing = false;
      }
      this.pageNum++;
      // this.getList();
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  // position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  .top {
    width: 100%;
    min-height: 864px;
    background: url("../assets/img/topBg.jpg") top center no-repeat;
    background-size: 100% auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    .icon {
      margin-top: 70px;
      margin-left: -40px;
      width: 610px;
      height: 242px;
      background: url("../assets/img/top-icon.png") center center no-repeat;
      background-size: 100% 100%;
    }

    .btn {
      margin-top: 8px;
      width: 304px;
      height: 106px;
      cursor: pointer;
      background: url("../assets/img/btn.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .text-top {
      margin-top: 122px;
      width: 583px;
      height: 28px;
      background: url("../assets/img/text-top.png") center center no-repeat;
      background-size: 100% 100%;
    }

    .text-box {
      margin-top: 28px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      .text-1 {
        margin-right: 30px;
        width: auto;
        height: 22px;
        font-family: SourceHanSansCN-Medium;
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
      }

      .blue-text {
        cursor: pointer;
        width: auto;
        height: 21px;
        font-family: SourceHanSansCN-Medium;
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #145878;
      }
    }
  }
  .outer-title {
    margin-top: 91px;
    width: 203px;
    height: 51px;
    background: url("../assets/img/outer-title.png") center center no-repeat;
    background-size: 100% 100%;
  }

  .outer-box {
    margin-top: -30px;
    position: relative;
    width: 1200px;
    height: 950px;
    overflow: hidden;
    padding: 40px 30px 150px;
    margin-bottom: 100px;
    border-radius: 20px;
    background: url("../assets/img/listBg.png") center center no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;

    .search-box {
      margin-top: -50px;
      margin-bottom: 40px;
      width: 432px;
      height: 41px;
      background-color: #ffffff;
      border-radius: 20px;
      position: relative;
      display: none;

      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 308px;
        height: 41px;
        padding-left: 20px;
        border-radius: 20px;
      }

      .search-btn {
        position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        width: 128px;
        height: 40px;
        background-color: #145878;
        border-radius: 20px;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }

  .content {
    position: relative;
    width: 1200px;
    height: 750px;
    margin-bottom: 100px;
    overflow-y: scroll;
    box-sizing: border-box;
  }

  .content-box {
    position: relative;
    width: 1140px;
    height: 750px;
    overflow-y: scroll;
    overflow-x: hidden;
    box-sizing: border-box;
    margin-bottom: 100px;

    .list-rank {
      position: relative;
      width: 100%;
      min-height: 100px;
      box-sizing: border-box;
    }

    .nice-title {
      width: 210px;
      height: 33px;
      margin: 0 auto;
      background: url("../assets/img/list-nice-tilte.png") center center
        no-repeat;
      background-size: 100% 100%;
    }

    .tran-title {
      width: 246px;
      height: 32px;
      margin: 0 auto;
      background: url("../assets/img/list-tran-title.png") center center
        no-repeat;
      background-size: 100% 100%;
    }
  }

  .is-last {
    margin: 30px auto 50px;
    color: #969799;
    font-size: 28px;
    line-height: 42px;
    text-align: center;
  }
}
.rank-list {
  position: relative;
  width: 100%;
  margin-bottom: 80px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  .item {
    position: relative;
    width: 370px;
    height: 213px;
    margin-top: 70px;
    img {
      width: 370px;
      height: 213px;
      border-radius: 15px;
    }
    .bottom-box {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0 0 18px 18px;
      backdrop-filter: blur(5px);
      text-align: left;

      .name {
        margin-top: 10px;
        margin-left: 20px;
        margin-right: 20px;
        width: 100%;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .title {
        margin-left: 20px;
        margin-right: 20px;
        width: 100%;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .rank1 {
      position: absolute;
      top: -45px;
      left: 0;
      width: 98px;
      height: 94px;
      background: url("../assets/img/rank1.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 1;
    }
    .rank2 {
      position: absolute;
      top: -45px;
      left: 0;
      width: 97px;
      height: 93px;
      background: url("../assets/img/rank2.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 1;
    }
    .rank3 {
      z-index: 1;
      position: absolute;
      top: -45px;
      left: 0;
      width: 97px;
      height: 94px;
      background: url("../assets/img/rank3.png") center center no-repeat;
      background-size: 100% 100%;
    }
  }
}
.other-title {
  width: 203px;
  height: 51px;
  margin: 0 auto 100px;
  background: url("../assets/img/other-title.png") center center no-repeat;
  background-size: 100% 100%;
}
.other-box {
  .content {
    position: relative;
    width: 1200px;
    height: 750px;
    margin-bottom: 100px;
    overflow-y: scroll;
    box-sizing: border-box;
  }
}
/deep/.real-list {
  z-index: 1;
  margin-top: 45px;
  position: relative;
  width: 100%;
  margin-bottom: 80px;

  img {
    width: 100%;
    border-radius: 15px;
  }
  .bottom-box {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 0 0 18px 18px;
    backdrop-filter: blur(5px);
    text-align: left;

    .name {
      margin-top: 10px;
      margin-left: 20px;
      margin-right: 20px;
      width: 100%;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .title {
      margin-left: 20px;
      margin-right: 20px;
      width: 100%;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
/deep/.vue-waterfall {
  overflow-x: hidden;
}
</style>
